import React from "react";

const ANIMAL_EMOJI = { egg: "🥚", hatchling: "🐣", fox: "🦊", owl: "🦉", lion: "🦁", dragon: "🐉" };

const STRENGTH_LABELS = ["Focus", "Memory", "Creativity", "Communication"];

function strengthStarsFromScore(score) {
  // Lightweight heuristic mapping — no raw IQ-style numbers shown to anyone.
  const pct = Math.min(100, Math.round((score / 1000) * 100));
  return Math.max(1, Math.round(pct / 20));
}

export default function ScoreBoard({ dailyTotalScore = 0, streakInfo }) {
  const stars = strengthStarsFromScore(dailyTotalScore);

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-[#F3EEFF] p-4 space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-bold text-[#2B2140]">Today's Play</h3>
        {streakInfo && (
          <div className="flex items-center gap-1 text-xs font-semibold text-[#7C3AED] bg-[#F3EEFF] px-2 py-1 rounded-full">
            <span aria-hidden="true">{ANIMAL_EMOJI[streakInfo.animalStage || "egg"]}</span>
            <span>{streakInfo.currentStreak || 0} day streak</span>
          </div>
        )}
      </div>

      <div className="grid grid-cols-2 gap-2">
        {STRENGTH_LABELS.map((label) => (
          <div key={label} className="flex items-center justify-between text-xs sm:text-sm">
            <span className="text-[#8B7FA8]">{label}</span>
            <span aria-label={`${stars} of 5`}>{"⭐".repeat(stars)}</span>
          </div>
        ))}
      </div>

      {streakInfo?.shieldsAvailable > 0 && (
        <div className="flex items-center gap-1.5 text-xs text-[#8B7FA8] bg-[#FFF8EE] rounded-xl px-2.5 py-1.5">
          <span aria-hidden="true">🛡️</span>
          <span>{streakInfo.shieldsAvailable} streak shield{streakInfo.shieldsAvailable > 1 ? "s" : ""} ready — protects a missed day</span>
        </div>
      )}
    </div>
  );
}
